import React, { useEffect } from 'react';
import { track } from '../../utils/analytics';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/ui/PageHeader';
import { BundleSelector } from '../../components/shop/BundleSelector';
import { PaymentTrust } from '../../components/shop/PaymentTrust';
import { sceneImages } from '../../data/images';
import { useLanguage } from '../../contexts/LanguageContext';
import { buttonClasses } from '../../utils/buttonStyles';
import { pricingConfig } from '../../data/pricing';
import { formatMoney } from '../../utils/pricing';
export function Systems() {
  const {
    t
  } = useLanguage();
  useEffect(() => {
    track('view_content', {
      content_name: 'M1 PRO Lighting Systems',
      content_ids: pricingConfig.bundles.map(b => b.variantId),
      content_type: 'product',
      value: pricingConfig.unitPrice,
      currency: 'USD'
    });
  }, []);
  return <>
      <PageHeader image={sceneImages.mediumPool} title={<>{t('systems.headline')}</>} lead={`Start with one professional-grade M1 PRO for ${formatMoney(pricingConfig.unitPrice)}, or transform the whole space with a complete system of 2 to 24 lights — the more lights, the lower the price per light.`} data-id="element-1415" data-mp="4ptzyzvu213m" />
      <section className="mx-auto max-w-site px-5 py-12 md:px-8 md:py-20" data-id="element-1416" data-mp="2potwb0kzgtsk">
        <BundleSelector data-id="element-1417" data-mp="2ksmnn017d46x" />
        <PaymentTrust className="mt-10 border-t mf-hairline pt-6" data-id="element-1418" data-mp="2kqaad06e3i07" />
      </section>
      <section className="border-t mf-hairline bg-navy" data-id="element-1419" data-mp="1x2sfgvrtw3t0">
        <div className="mx-auto flex max-w-site flex-col items-start justify-between gap-6 px-5 py-14 md:flex-row md:items-center md:px-8" data-id="element-1420" data-mp="1s47cwpp3t81e">
          <div data-id="element-1421" data-mp="26tn2w3gt99g1">
            <h2 className="font-display text-3xl font-semibold uppercase" data-id="element-1422" data-mp="26u57bndmmtz1">Need a different number?</h2>
            <p className="mt-2 text-titanium" data-id="element-1423" data-mp="1ec16vwfo0hfo">Build your own system with any quantity, starting at one light.</p>
          </div>
          <Link to="/build" className={buttonClasses('secondary')} data-id="element-1424" data-mp="19dpxfmta88xz">
            {t('paths.byo')}
          </Link>
        </div>
      </section>
    </>;
}